import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import App from './App';
import { store } from './store';
import theme from './theme/index';
// Import axios config to ensure it's initialized before any API calls
import './utils/axiosConfig';
import { AuthProvider } from "react-oidc-context";
import { COGNITO_AUTHORITY, COGNITO_CLIENT_ID, REDIRECT_URI } from './config/cognito';

const cognitoAuthConfig = {
    authority: COGNITO_AUTHORITY,
    client_id: COGNITO_CLIENT_ID,
    redirect_uri: REDIRECT_URI,
    post_logout_redirect_uri: REDIRECT_URI,
    response_type: "code",
    scope: "phone openid email profile",
    onSigninCallback: () => {
        window.history.replaceState({}, document.title, window.location.pathname);
    }
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
      <AuthProvider {...cognitoAuthConfig}>
        <Provider store={store}>
          <BrowserRouter>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <App />
            </ThemeProvider>
          </BrowserRouter>
        </Provider>
          </AuthProvider>
  </React.StrictMode>
);

